// import { Schema } from '../models/schema';
// import { Field } from '../models/field';

export interface ActionData {
  action: string;
  name: string;
  params: any;
}

export interface ResultRow {
  status: number;
  result: any;
}

export interface DataResult {
  [ name: string ]: ResultRow;
}

export interface AbstractQueryAction {
  serialize(): ActionData;
}

export class AbstractQuery implements AbstractQueryAction {

  public static build(operationName: string, resultName: string = '', payload: any): AbstractQuery {
    const dq = new AbstractQuery(resultName);
    dq.jsonAction = {
      action: operationName,
      name: resultName,
      params: {
        ...payload,
      },
    };
    return dq;
  }

  public jsonAction: ActionData | null = null;

  protected constructor(public resultName: string) { }

  public serialize(): ActionData {
    if (this.jsonAction == null) {
      throw new Error('Unvalid query');
    } else  {
      return this.jsonAction;
    }
  }

}

export const OPERATION_NO_ERRORS: number = 0;
export const OPERATION_ERROR_FATAL: number = 1;
export const OPERATION_ERROR_STANDART: number = 2;
